<template>
  <div>
    <VSectionBar
      id="special-benefit"
      message="LINE限定特典"
    />
    <v-container
      class=main--text
      fluid>
      <v-row
        justify=center>
        <v-col
          cols=12
          md=6>
          <VLineBenefitCard/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VSectionBar from '@/components/molecules/VSectionBar.vue'
import VLineBenefitCard from '@/components/organisms/lp/VLineBenefitCard.vue'

export default {
  name: 'VLineBenefit',
  components: {
    VLineBenefitCard,
    VSectionBar
  }
}
</script>